import {
  AB_TESTS_CONTROL,
  ACCEPT_HEADER,
  ACCEPT_HEADER_DOCUMENT_TYPE,
  COOKIE_HEADER,
  GB_COOKIE_NAME,
  GROWTHBOOK_PAYLOAD_PATH,
  SET_COOKIE_HEADER,
} from './constants';

export { FeatureFlagsProvider, type ExperimentPayload } from './FeatureFlagsProvider';
export { useIsFeatureActive } from './useIsFeatureActive';
export { useExtractFeatureFlagOverrides } from './useExtractFeatureFlagOverrides';
export * from './types';
export * from './utils';
export * from './growthbook-server';
export * from './tracking';

export const constants = {
  GB_COOKIE_NAME,
  AB_TESTS_CONTROL,
  COOKIE_HEADER,
  SET_COOKIE_HEADER,
  ACCEPT_HEADER,
  ACCEPT_HEADER_DOCUMENT_TYPE,
  GROWTHBOOK_PAYLOAD_PATH,
} as const;
